import { render, staticRenderFns } from "./collarbone.vue?vue&type=template&id=674b27e1"
import script from "./collarbone.vue?vue&type=script&lang=js"
export * from "./collarbone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports